import {initializeClientIframe} from "./client-iframe";

/**
 * Initialize the sortable elements.
 */
export function initializeSortableElements() {
    // Initialize variables
    var sortable;

    // Loop through each sortable items element
    for (let element of document.querySelectorAll('[data-sortable-items]')) {
        // If the element is a sortable object, destroy it
        sortable = Sortable.get(element);
        if (sortable) {
            sortable.destroy();
        }

        // Check if this sortable list type is for sections
        if (element.getAttribute('data-sortable-items') === 'section') {
            // Initialize the sortable instance on the element
            new Sortable(element, {
                animation: 150,
                handle: '.sortable-section-handle',
                ghostClass: 'on-sortable-drag',
                fallbackOnBody: true,
                swapThreshold: 0.5,
                onUpdate: function (e) {
                    sortCustompageSections(e);
                },
            });

            // Check if this sortable list type is for blocks
        } else if (element.getAttribute('data-sortable-items') === 'block') {
            // Initialize the sortable instance on the element
            new Sortable(element, {
                handle: '.sortable-block-handle',
                animation: 150,
                ghostClass: 'on-sortable-drag',
                fallbackOnBody: true,
                swapThreshold: 0.5,
                group: 'sortableblocks',
                onAdd: function (e) {
                    sortCustompageBlocks(e);
                },
                onUpdate: function (e) {
                    sortCustompageBlocks(e);
                },
            });

            // Check if this sortable list type is for menus
        } else if (element.getAttribute('data-sortable-items') === 'menu') {
            // Initialize the sortable instance on the element
            new Sortable(element, {
                animation: 150,
                handle: '.sortable-menu-handle',
                ghostClass: 'on-sortable-drag',
                onUpdate: function (e) {
                    sortDiyMenus(e);
                },
            });

            // Check if this sortable list type is for menu items
        } else if (element.getAttribute('data-sortable-items') === 'menuitem') {
            // Initialize the sortable instance on the element
            new Sortable(element, {
                group: 'nested',
                animation: 150,
                handle: '.sortable-menuitem-handle',
                fallbackOnBody: true,
                swapThreshold: 0.5,
                onEnd: function (e) {
                    sortDiyMenuItems(e);
                },
            });
        } else if (element.getAttribute('data-sortable-items') === 'teamItem') {
            // Initialize the sortable instance on the element
            new Sortable(element, {
                group: 'nested',
                animation: 150,
                handle: '.sortable-teamItem-handle',
                fallbackOnBody: true,
                swapThreshold: 0.5,
                onEnd: function (e) {
                    sortTeams(e);
                },
            });
        } else if (element.getAttribute('data-sortable-items') === 'options') {
            // Initialize the sortable instance on the element
            new Sortable(element, {
                animation: 150,
                handle: '.sortable-option-handle',
                ghostClass: 'on-sortable-drag',
                onUpdate: function (e) {
                    //sortQuestionOptions(e);
                },
            });

            // Check if this sortable list type is for menu items
        } else if (element.getAttribute('data-sortable-items') === 'table') {
            $(element).sortable({
                axis: 'y',
                helper: fixHelper,
                update: function (event, ui) {
                    let row = [];
                    $(element).find('tr').each(function (index) {
                        row[index] = $(this).data('uuid');
                    });

                    new Load(true);

                    $.ajax({
                        type: 'POST',
                        url: $(element).data('action'),
                        data: {'sort': row},
                        success: function (data) {
                            toastr["success"](
                                data.message
                            );

                            if (data.reload !== undefined && data.reload !== false) {
                                setTimeout(function () {
                                    location.reload();
                                }, 500)
                            } else {
                                new Load(false);
                            }
                        },
                        error: function (data) {
                            let response = JSON.parse(data.responseText);
                            toastr["error"](
                                response.message
                            );
                            new Load(false);
                        },
                    });
                }
            });
        }
    }

}

function setSortableOnDataTable() {
    let action = $('[data-sortable-items="datatable"]').data('action');
    let element = document.querySelector('[data-sortable-items="datatable"] tbody');
    $(element).sortable({
        axis: 'y',
        helper: fixHelper,
        update: function (event, ui) {
            let row = [];
            $(element).find('tr').each(function (index) {
                row[index] = $(this).data('uuid');
            });

            new Load(true);

            $.ajax({
                type: 'POST',
                url: action,
                data: {'sort': row},
                success: function (data) {
                    toastr["success"](
                        data.message
                    );

                    if (data.reload !== undefined && data.reload !== false) {
                        setTimeout(function () {
                            location.reload();
                        }, 500)
                    } else {
                        new Load(false);
                    }
                },
                error: function (data) {
                    let response = JSON.parse(data.responseText);
                    toastr["error"](
                        response.message
                    );
                    new Load(false);
                },
            });
        }
    });
}

window.setSortableOnDataTable = setSortableOnDataTable;

/**
 * Sort sections.
 */
function sortCustompageSections(e) {

    // Initialize variables
    var container = $(e.target);
    var element = $(e.item);
    var uuids = {};

    // Fetch the UUIDs and store them into an object along with their current indexes
    container.children('[data-entity="section"]').each(function (index) {
        uuids[$(this).data('uuid')] = {
            index: index,
            uuid: $(this).data('uuid'),
        };
    });

    // Fetch the UUIDs and store them into an object along with their current indexes
    $.ajax({
        url: container.data('url'),
        method: 'POST',
        data: {
            uuids: uuids,
            _token: $('meta[name="csrf-token"]').attr('content')
        }, success: function (data) {
            toastr["success"](
                data.message
            );
            $('[data-sortable-items="section"] [data-entity="section"][data-uuid="' + data.section_uuid + '"] [data-sortable-items="block"] [data-entity="block"][data-uuid="' + data.block_uuid + '"]').replaceWith(data.view);
            $('.iframe-container iframe').attr('src', $('.iframe-container').data('action'));
            initializeClientIframe();
        }, error: function (data) {
            let response = JSON.parse(data.responseText);
            toastr["error"](
                response.message
            );
        }, fail: function (jqXHR, textStatus, errorThrown) {
            alert(jqXHR.status + ' - ' + errorThrown);
        }
    });

}

/**
 * Sort blocks.
 */
function sortCustompageBlocks(e) {

    // Initialize variables
    var container = $(e.target);
    var element = $(e.item);
    var block_uuid = element.data('uuid');
    var section_uuid = element.closest('[data-entity="section"]').data('uuid');

    // Fetch the section's block UUIDs and store them into an object along with their current indexes
    var section_block_uuids = {};
    container.children('[data-entity="block"]').each(function (index) {
        section_block_uuids[$(this).data('uuid')] = {
            index: index,
            uuid: $(this).data('uuid'),
        };
    });

    // Run the AJAX request
    $.ajax({
        url: container.data('url'),
        method: 'POST',
        data: {
            section_uuid: section_uuid,
            block_uuid: block_uuid,
            section_block_uuids: section_block_uuids,
            _token: $('meta[name="csrf-token"]').attr('content')
        }, success: function (data) {
            toastr["success"](
                data.message
            );
            $('[data-sortable-items="section"] [data-entity="section"][data-uuid="' + data.section_uuid + '"] [data-sortable-items="block"] [data-entity="block"][data-uuid="' + data.block_uuid + '"]').replaceWith(data.view);
            $('.iframe-container iframe').attr('src', $('.iframe-container').data('action'));
            initializeClientIframe();

            if (data.reload !== undefined && data.reload !== false) {
                setTimeout(function () {
                    location.reload();
                }, 500)
            }
        }, error: function (data) {
            let response = JSON.parse(data.responseText);
            toastr["error"](
                response.message
            );
        }, fail: function (jqXHR, textStatus, errorThrown) {
            alert(jqXHR.status + ' - ' + errorThrown);
        }
    });

}

/**
 * Sort DIY menus.
 */
function sortDiyMenus(e) {

    // Initialize variables
    var container = $(e.target);
    var element = $(e.item);
    var uuids = {};

    // Fetch the UUIDs and store them into an object along with their current indexes
    container.children('[data-entity="menu"]').each(function (index) {
        uuids[$(this).data('uuid')] = {
            index: index,
            uuid: $(this).data('uuid'),
        };
    });

    // Fetch the UUIDs and store them into an object along with their current indexes
    $.ajax({
        url: container.data('url'),
        method: 'POST',
        data: {
            uuids: uuids,
            _token: $('meta[name="csrf-token"]').attr('content')
        },
        success: function (data) {
            toastr["success"](
                data.message
            );

            if (data.reload !== undefined && data.reload !== false) {
                setTimeout(function () {
                    location.reload();
                }, 500)
            }
        }, error: function (data) {
            let response = JSON.parse(data.responseText);
            toastr["error"](
                response.message
            );
        }, fail: function (jqXHR, textStatus, errorThrown) {
            alert(jqXHR.status + ' - ' + errorThrown);
        }
    });

}

/**
 * Sort DIY menus.
 */
function sortQuestionOptions(e) {

    // Initialize variables
    var container = $(e.target);
    var element = $(e.item);
    var uuids = {};

    // Fetch the UUIDs and store them into an object along with their current indexes
    container.children('[data-entity="option"]').each(function (index) {
        uuids[$(this).data('uuid')] = {
            index: index,
            uuid: $(this).data('uuid'),
        };
    });

    // Fetch the UUIDs and store them into an object along with their current indexes
    $.ajax({
        url: $('.custom-question-container').data('url'),
        method: 'POST',
        data: {
            uuids: uuids,
            _token: $('meta[name="csrf-token"]').attr('content')
        },
        success: function (data) {
            toastr["success"](
                data.message
            );

            if (data.reload !== undefined && data.reload !== false) {
                setTimeout(function () {
                    location.reload();
                }, 500)
            }
        }, error: function (data) {
            let response = JSON.parse(data.responseText);
            toastr["error"](
                response.message
            );
        }, fail: function (jqXHR, textStatus, errorThrown) {
            alert(jqXHR.status + ' - ' + errorThrown);
        }
    });

}

/**
 * Sort DIY menu items.
 */
function sortDiyMenuItems() {

    // Initialize variables
    var uuids = {};

    // Fetch the UUIDs and store them into an object along with their current indexes
    //$('[data-sortable-items="menuitem"]').find('[data-entity="menuitem"]').each(function(index) {
    $('[data-entity="menuitem"]').each(function () {

        // Initialize variables
        var uuid = $(this).data('uuid');
        var index = $(this).index();
        var parent = null;

        // Define the parent UUID
        if ($(this).parents('[data-entity="menuitem"]').first().length) {
            parent = $(this).parents('[data-entity="menuitem"]').first().data('uuid');
        }

        // Add the UUID data to the array
        uuids[uuid] = {
            uuid: uuid,
            index: index,
            parent: parent,
        };

    });

    $.ajax({
        url: $('#menuitem-container').data('url'),
        method: 'POST',
        data: {
            uuids: uuids,
            _token: $('meta[name="csrf-token"]').attr('content')
        },
        success: function (data) {
            toastr["success"](
                data.message
            );

            if (data.reload !== undefined && data.reload !== false) {
                setTimeout(function () {
                    location.reload();
                }, 500)
            }
        }, error: function (data) {
            let response = JSON.parse(data.responseText);
            toastr["error"](
                response.message
            );
        }, fail: function (jqXHR, textStatus, errorThrown) {
            alert(jqXHR.status + ' - ' + errorThrown);
        }
    });
}

/**
 * Sort DIY menu items.
 */
function sortTeams() {

    // Initialize variables
    var uuids = {};

    // Fetch the UUIDs and store them into an object along with their current indexes
    //$('[data-sortable-items="menuitem"]').find('[data-entity="menuitem"]').each(function(index) {
    $('[data-entity="teamItem"]').each(function () {

        // Initialize variables
        var uuid = $(this).data('uuid');
        var index = $(this).index();
        var parent = null;

        // Define the parent UUID
        if ($(this).parents('[data-entity="teamItem"]').first().length) {
            parent = $(this).parents('[data-entity="teamItem"]').first().data('uuid');
        }

        // Add the UUID data to the array
        uuids[uuid] = {
            uuid: uuid,
            index: index,
            parent: parent,
        };

    });

    $.ajax({
        url: $('#team-container').data('url'),
        method: 'POST',
        data: {
            uuids: uuids,
            _token: $('meta[name="csrf-token"]').attr('content')
        },
        success: function (data) {
            toastr["success"](
                data.message
            );

            if (data.reload !== undefined && data.reload !== false) {
                setTimeout(function () {
                    location.reload();
                }, 500)
            }
        }, error: function (data) {
            let response = JSON.parse(data.responseText);
            toastr["error"](
                response.message
            );
        }, fail: function (jqXHR, textStatus, errorThrown) {
            alert(jqXHR.status + ' - ' + errorThrown);
        }
    });
}

let fixHelper = function (e, ui) {
    ui.children().each(function () {
        $(this).width($(this).width());
    });
    return ui;
};
